import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import LatestIssue from "./components/LatestIssue";
import RealWeddings from "./components/RealWeddings";
import FashionBeautySection from "./components/FashionBeautySection";
import TipsInspirationSection from "./components/TipsInspirationSection";
import EventsSection from "./components/EventsSection";
import OurFocusSection from "./components/OurFocusSection";
import InstagramFeed from "./components/InstagramFeed";
import AdvertisingBanner from "./components/AdvertisingBanner";
import PartnersSection from "./components/PartnersSection";
import FeaturedVendorsSection from "./components/FeaturedVendorsSection";
import FeaturedArticle from "./components/FeaturedArticle";
import CountdownCTA from "./components/CountdownCTA";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdvertisePage from "./pages/AdvertisePage";
import MagazinePage from "./pages/MagazinePage";
import RealWeddingsPage from "./pages/RealWeddingsPage";
import WeddingDetailPage from "./pages/WeddingDetailPage";
import PartnersPage from "./pages/PartnersPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import BlogPage from "./pages/BlogPage";
import WeddingSubmissionPage from "./pages/WeddingSubmissionPage";
import CountdownPage from "./pages/CountdownPage";
import MagazineDetailPage from "./pages/MagazineDetailPage";
import SearchPage from "./pages/SearchPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PartnerDetailPage from "./pages/PartnerDetailPage";
import WeddingChecklistPage from "./pages/WeddingChecklistPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import SEO from "./components/SEO";
import CookieConsent from "./components/CookieConsent";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div>
      <SEO
        title='Where "Yes" Turns Into "I Do"'
        description="Malta's premier bridal magazine featuring real wedding stories, expert planning tips, top wedding vendors, and inspiration for your dream Mediterranean wedding."
      />
      <Hero />
      <PartnersSection />
      <OurFocusSection />
      <LatestIssue />
      <RealWeddings />
      <FashionBeautySection />
      <FeaturedArticle />
      <FeaturedVendorsSection />
      <AdvertisingBanner />
      <EventsSection />
      <CountdownCTA />
      <TipsInspirationSection />
      <InstagramFeed />
    </div>
  );
};

function App() {
  useEffect(() => {
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) badge.remove();
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

function AppLayout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  return (
    <>
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/advertise" element={<AdvertisePage />} />
        <Route path="/magazine" element={<MagazinePage />} />
        <Route path="/the-magazine" element={<MagazinePage />} />
        <Route path="/the-magazine/:id" element={<MagazineDetailPage />} />
        <Route path="/wedding-stories" element={<RealWeddingsPage />} />
        <Route path="/wedding-stories/:slug" element={<WeddingDetailPage />} />
        <Route path="/real-weddings" element={<RealWeddingsPage />} />
        <Route path="/tips-inspiration" element={<BlogPage />} />
        <Route path="/tips-inspiration/:slug" element={<ArticleDetailPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/partners/:slug" element={<PartnerDetailPage />} />
        <Route path="/submit-wedding" element={<WeddingSubmissionPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/checklist" element={<WeddingChecklistPage />} />
        <Route path="/countdown" element={<CountdownPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <CookieConsent />}
      <Toaster />
    </>
  );
}

export default App;